import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import {useStores} from "../../stores";
import {routes} from "../../routing/routes";

export const SessionExpiredNotification: React.FC = observer(() => {
    const {authStore} = useStores();
    const navigate = useNavigate();
    const open = authStore.isTokenInvalid;

    const handleSignIn = () => {
        authStore.authentication.clearSession();
        authStore.authentication.resetExpiredFlag();
        navigate(routes.login, {replace: true});
    };

    return (
        <Modal
            open={open}
            disableEscapeKeyDown
            aria-labelledby="session-expired-title"
            sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                p: 2,
            }}
        >
            <Alert
                id="session-expired-title"
                severity="info"
                variant="filled"
                sx={{width: "50%", minWidth: 320, alignItems: "center"}}
                action={
                    <Button variant="contained" color="info"  size="small" onClick={handleSignIn}>
                        Sign in
                    </Button>
                }
            >
                You have been logged out due to inactivity.
            </Alert>
        </Modal>
    );
});
